export class Applynow {
    
    public static onSubmitValidationMessage:string="Selected file is invalid";
    public static onSubmitChooseFileMessage:string="Please select CV from dropdown or upload new CV";
    public static onSubmitAppliedJobMessage:string="You have already applied for this job.";
    public static postJobApplicationAppliedMessage:string="Your application has been sent successfully.";
    public static postJobApplicationAppliedExpiredJob:string="This job no longer available.";
    public static QuickJobApplyNoResumeUploaded:string = "Please upload resume to apply for this job.";
}
